import { DepartmentStore } from '@stores';
import { inject, Injectable } from "@angular/core";
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DepartmentResolver implements Resolve<void> {
    readonly store = inject(DepartmentStore);

    resolve(): Observable<void> | Promise<void> | void {
        return this.store.load();
    }
}